import styled from "styled-components";
import { GridContainer } from "../Forms.css";

export const Content = styled("div")`
  p {
    margin: 12px;
  }
`;

export const GridContainerAligned = styled(GridContainer)(() => ({
  marginBottom: "24px",
}));
